module.exports = __webpack_public_path__ + "img/portugal.8b28449d.svg";